import React from 'react';
import SEO from "../common/SEO";
import HeaderOne from '../common/header/HeaderOne';
import HeaderTopBar from '../common/header/HeaderTopBar';
import CounterUpFour from '../elements/counterup/CounterUpFour';
import CalltoActionFive from '../elements/calltoaction/CalltoActionFive';
import SectionTitle from "../elements/sectionTitle/SectionTitle";
import Separator from "../elements/separator/Separator";
import TestimonialOne from '../elements/testimonial/TestimonialOne';
import TimelineTwo from '../elements/timeline/TimelineTwo';
import Slider from "react-slick";
import { BannerActivation } from "../utils/script";
import ProductImageGallery from '../elements/product/ProductImageGallery';
import HomeProductImagesData from '../data/products/HomeProductImagesData';
import { Link } from 'react-router-dom';
import { FiArrowRight } from "react-icons/fi";
import ScrollAnimation from 'react-animate-on-scroll';
import FooterTwo from '../common/footer/FooterTwo';
import WhoWeAre from '../elements/about/WhoWeAre';
import OrdersExecuted from '../elements/OrdersExecuted/OrdersExecuted';

// Fallback data in case API fails
const FallbackBannerData = [
  {
    image: "/images/bg/bg55.webp",
    alttext: "Global steel structure manufacturers",
    title: "Connecting Quality with Confidence.Where technology meets trust.",
    description:
      "KR Power Supports Pvt. Ltd. specializes in manufacturing premium, sustainable Cable Tray Systems, Electrical Control & Automation Panels, Solar Module Mounting Structures, and advanced Earthing & Lightning Protection Systems for global energy needs."
  },
  // {
  //   image: "/images/bg/bg54.webp",
  //   alttext: "Global steel structure manufacturers",
  //   title: "Connecting Quality with Confidence.Where technology meets trust.",
  //   description:
  //     "KR Power Supports Pvt. Ltd. specializes in manufacturing premium, sustainable Cable Tray Systems, Electrical Control & Automation Panels, Solar Module Mounting Structures, and advanced Earthing & Lightning Protection Systems for global energy needs."
  // },
  // {
  //   image: "/images/bg/bg53.webp",
  //   alttext: "Global steel structure manufacturers",
  //   title: "Connecting Quality with Confidence.Where technology meets trust.",
  //   description:
  //     "KR Power Supports Pvt. Ltd. specializes in manufacturing premium, sustainable Cable Tray Systems, Electrical Control & Automation Panels, Solar Module Mounting Structures, and advanced Earthing & Lightning Protection Systems for global energy needs."
  // },
  // {
  //   image: "/images/bg/bg56.webp",
  //   alttext: "Global steel structure manufacturers",
  //   title: "Connecting Quality with Confidence.Where technology meets trust.",
  //   description:
  //     "KR Power Supports Pvt. Ltd. specializes in manufacturing premium, sustainable Cable Tray Systems, Electrical Control & Automation Panels, Solar Module Mounting Structures, and advanced Earthing & Lightning Protection Systems for global energy needs."
  // },
  // {
  //   image: "/images/bg/bg52.webp",
  //   alttext: "Global steel structure manufacturers",
  //   title: "Connecting Quality with Confidence.Where technology meets trust.",
  //   description:
  //     "KR Power Supports Pvt. Ltd. specializes in manufacturing premium, sustainable Cable Tray Systems, Electrical Control & Automation Panels, Solar Module Mounting Structures, and advanced Earthing & Lightning Protection Systems for global energy needs."
  // },
  {
    image: "/images/bg/bg51.webp",
    alttext: "Global solar structure manufacturers",
    title: "We design and build reliable electrical systems powering global industries with safety and precision.",
    // description:
    //   "We design and build reliable electrical systems powering global industries with safety and precision."
  }
];

const Home = () => {
  const bannerData = FallbackBannerData;

  return (
    <>
      <SEO pageKey="home" />
      <main className="page-wrapper">
        <HeaderTopBar />
        <HeaderOne btnStyle="btn-small" HeaderSTyle="header-relative" />

        {/* ✅ START SLIDER AREA */}
        {bannerData.length > 0 && (
          <Slider
            className="slider-area slider-style-4 variation-2 slider-dot rn-slick-dot rn-slick-arrow"
            {...BannerActivation}
          >
            {bannerData.map((data, index) => (
              <div key={index} className="single-slide">
                <div
                  className="height-750 bg-overlay bg_image"
                  style={{
                    ...(data.image ? { backgroundImage: `url(${process.env.PUBLIC_URL}${data.image})` } : {}),
                    backgroundColor: data.image ? 'transparent' : '#f3f4f6'
                  }}
                  aria-label={data.alttext}
                >
                  <div className="container">
                    <div className="row row--30 align-items-center">
                      <div className="col-lg-12">
                        <div className="inner text-center">
                          {data.title && (
                            <h1
                              className="title"
                              dangerouslySetInnerHTML={{ __html: data.title }}
                            />
                          )}

                          {data.description && (
                            <p
                              className="description"
                              dangerouslySetInnerHTML={{
                                __html: data.description
                              }}
                            />
                          )}

                          <div className="button-group mt--30"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        )}
        {/* End Slider Area  */}


        <Separator />




        {/* <AboutSeven image="./images/about/contact-image.png" />  */}
        <hr />



        <WhoWeAre />


        <Separator />


        {/* Start Product Gallery Area  */}
        <ProductImageGallery
          subtitle="PRODUCT GALLERY"
          title="Innovative Products, Trusted Performance.!"
          description=""
          sectionClass="rn-section-gap"
          items={HomeProductImagesData}
        >
          <div className="call-to-btn text-center mt--40">
            <ScrollAnimation
              animateIn="fadeInUp"
              animateOut="fadeInOut"
              animateOnce={true}
              className="button-group">
              <Link className="btn-default btn-small btn-icon" to="/products">Explore Our Products <i className="icon"><FiArrowRight /></i></Link>
            </ScrollAnimation>
          </div>
        </ProductImageGallery>
        {/* End Product Gallery Area  */}
        <Separator />

        {/* <Aboutone /> */}

        <Separator />

        {/* Start Service Area  */}
        {/* <div className="rn-service-area rn-section-gap ">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <SectionTitle
                                        textAlign = "text-center"
                                        radiusRounded = ""
                                        subtitle = "Our Services"
                                        title = "Delivering Power With Precision"
                                        // description = "There are many variations of passages of Lorem Ipsum available, <br /> but the majority have suffered alteration."
                                     />
                                </div>
                            </div>
                            <ServiceThree 
                                serviceStyle = "service__style--2"
                                textAlign = "text-center"
                             />
                        </div>
                    </div> */}
        {/* End Service Area  */}



        <Separator />

        {/* Start Elements Area 
                <div className="rwt-advance-tab-area rn-section-gap">
                    <div className="container">
                        <div className="row mb--40">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign = "text-center"
                                    radiusRounded = ""
                                    subtitle = "Smart Consulting. Real Results"
                                    title = "Your Trusted Tech Partner in Tirunelveli"
                                    description = ""
                                />
                            </div>
                        </div>
                       
                    </div>
                </div>
                 End Elements Area  */}

        <Separator />
        {/* Start Timeline Area  */}
        <div className="rwt-timeline-area rn-section-gap">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <SectionTitle
                  textAlign="text-center"
                  radiusRounded=""
                  subtitle="Way Of Working"
                  title="Our Working Process"
                  description="Delivering smart, reliable solutions through a skilled and experienced team."
                />
                {/* At Jaz Infotech, we follow a clear, collaborative, and results-driven process to turn your ideas<br /> into powerful digital solutions. From planning to delivery, every step is focused on quality, transparency, and your success. */}
              </div>
            </div>
            <div className="row">
              <div className="col-lg-10 offset-lg-1 mt--50">
                <TimelineTwo />
              </div>
            </div>
          </div>
        </div>


        <Separator />


        {/* Start Brand Area 
                  <div className="rwt-brand-area rn-section-gap">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <SectionTitle
                                        textAlign = "text-center"
                                        radiusRounded = ""
                                        subtitle = "OUR CLIENTS"
                                        title = "Brands That Believe in Us."
                                        description = ""
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12 mt--10">
                                    <BrandFour brandStyle="brand-style-2 variation-2" />
                                </div>
                            </div>
                        </div>
                    </div> */}
        {/* End Brand Area  */}

        <Separator />
        {/* Start Elements Area  */}
        <div className="rwt-testimonial-area rn-section-gap">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 mb--10">
                <SectionTitle
                  textAlign="text-center"
                  radiusRounded=""
                  subtitle="Words That Matter"
                  title="Your Feedback Fuels Our Innovation."
                // description = "Clients trust Jaz Infotech, Tirunelveli’s leading IT company, for creative, responsive, and result-driven web solutions."
                />

              </div>
            </div>
            <TestimonialOne column="col-lg-4 col-md-6 col-12 mt--30" teamStyle="card-style-default testimonial-style-one" />
          </div>
        </div>
        {/* End Elements Area  */}


        {/* Start Elements Area  */}
        <div className="rwt-counterup-area pb--40 pt--40">
          <div className="container">
            <CounterUpFour column="col-lg-6 col-md-6 col-sm-6 col-12" counterStyle="counter-style-4" textALign="text-center" />
          </div>
        </div>
        {/* End Elements Area  */}
        <Separator />

        {/* <div className="social-media-area rn-section-gap">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <SectionTitle
                  textAlign="text-center"
                  radiusRounded=""
                  subtitle="Follow Us"
                  title="Connect With Us on Social Media"
                  description="Stay updated with our latest updates, news, and insights across our social media platforms."
                />
              </div>
            </div>
            <SocialMediaFeeds />
          </div>
        </div> */}




        {/* <div className="contact-area rn-section-gapBottom">
                    <div className="container">
                        <div className="row mb--20">
                            <div className="col-lg-12">
                                <SectionTitleTwo
                                    Title= "Contact Us"
                                    textAlign= "text-start"
                                />
                            </div>
                        </div>
                        <div className="row row--30 mt--40">
                            <div className="col-lg-6 order-2 oder-lg-1 mt_md--30 mt_sm--30">
                                <ContactForm formStyle="contact-form-1" />
                            </div>
                            <div className="col-lg-6 order-1 oder-lg-2">
                                <div className="thumbnail">
                                    <img className="radius w-100" src="./images/about/contact-image.png" alt="Global cable tray manufacturers" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}

        {/* Start Elements Area  */}
        {/* <div className="rwt-team-area rn-section-gap">
                    <div className="wrapper plr--65 plr_sm--15">
                        <div className="row mb--20">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign = "text-center"
                                    radiusRounded = ""
                                    subtitle = "Our Experts."
                                    title = "Our Experts"
                                    description = ""
                                />
                            </div>
                        </div>
                        <TeamFour column="col-lg-6 col-xl-3 col-md-6 col-12 mt--30" teamStyle="team-style-three" />
                    </div>
                </div> */}
        {/* End Elements Area  */}
        <OrdersExecuted />

        <br />
        <br />



        {/* Start Elements Area  */}
        <div className="rwt-callto-action-area rn-section-gapBottom">
          <div className="wrapper">
            <CalltoActionFive />
          </div>
        </div>
        {/* End Elements Area  */}
        <Separator />


        <FooterTwo />
        {/* <Copyright /> */}
      </main>

    </>
  )
}

export default Home